import light_normal1 from "../imgs/mesh/light_normal1.png";
import light_normal2 from "../imgs/mesh/light_normal2.png";
import light_normal3 from "../imgs/mesh/light_normal3.png";
import light_normal4 from "../imgs/mesh/light_normal4.png";
import light_normal5 from "../imgs/mesh/light_normal5.png";
import light_normal6 from "../imgs/mesh/light_normal6.png";
import light_normal7 from "../imgs/mesh/light_normal7.png";
import light_normal8 from "../imgs/mesh/light_normal8.png";
import light_normal9 from "../imgs/mesh/light_normal9.png";
import light_normal10 from "../imgs/mesh/light_normal10.png";
import light_normal11 from "../imgs/mesh/light_normal11.png";
import light_normal12 from "../imgs/mesh/light_normal12.png";
import light_select1 from "../imgs/mesh/light_select1.png";
import light_select2 from "../imgs/mesh/light_select2.png";
import light_select3 from "../imgs/mesh/light_select3.png";
import light_select4 from "../imgs/mesh/light_select4.png";
import light_select5 from "../imgs/mesh/light_select5.png";
import light_select6 from "../imgs/mesh/light_select6.png";
import light_select7 from "../imgs/mesh/light_select7.png";
import light_select8 from "../imgs/mesh/light_select8.png";
import light_select9 from "../imgs/mesh/light_select9.png";
import light_select10 from "../imgs/mesh/light_select10.png";
import light_select11 from "../imgs/mesh/light_select11.png";
import light_select12 from "../imgs/mesh/light_select12.png";



export const getGroupSelectImgWithName = (name) => {
  if(name=="icon_light_fixture1" || name==1){
      return light_select1;
  }else if(name=="icon_light_fixture2" || name==2){
      return light_select2;
  }else if(name=="icon_light_fixture3" || name==3){
      return light_select3;
  }else if(name=="icon_light_fixture4" || name==4){
      return light_select4;
  }else if(name=="icon_light_fixture5" || name==5){
      return light_select5;
  }else if(name=="icon_light_fixture6" || name==6){
      return light_select6;
  }else if(name=="icon_light_fixture7" || name==7){
      return light_select7;
  }else if(name=="icon_light_fixture8" || name==8){
      return light_select8;
  }else if(name=="icon_light_fixture9" || name==9){
      return light_select9;
  }else if(name=="icon_light_fixture10" || name==10){
      return light_select10;
  }else if(name=="icon_light_fixture11" || name==11){
      return light_select11;
  }else if(name=="icon_light_fixture12" || name==12){
      return light_select12;
  }else{
      return light_select1;
  }
}

export const getGroupNormalImgWithName = (name) => {
  if(name=="icon_light_fixture1" || name==1){
      return light_normal1;
  }else if(name=="icon_light_fixture2" || name==2){
      return light_normal2;
  }else if(name=="icon_light_fixture3" || name==3){
      return light_normal3;
  }else if(name=="icon_light_fixture4" || name==4){
      return light_normal4;
  }else if(name=="icon_light_fixture5" || name==5){
      return light_normal5;
  }else if(name=="icon_light_fixture6" || name==6){
      return light_normal6;
  }else if(name=="icon_light_fixture7" || name==7){
      return light_normal7;
  }else if(name=="icon_light_fixture8" || name==8){
      return light_normal8;
  }else if(name=="icon_light_fixture9" || name==9){
      return light_normal9;
  }else if(name=="icon_light_fixture10" || name==10){
      return light_normal10;
  }else if(name=="icon_light_fixture11" || name==11){
      return light_normal11;
  }else if(name=="icon_light_fixture12" || name==12){
      return light_normal12;
  }else{
      return light_normal1;
  }
}

export const getGroupImgName = (mId) => {
  return "icon_light_fixture"+parseInt(mId+1);
}

